import * as React from 'react';
import {
	CheckboxGroup,
	FormCheckConditional,
	TextInput,
	ToggleSwitch,
	Label
} from '../../../../../components/forms';
import handleNoneOptionAndValidationHOC from '../handleNoneOptionAndValidationHOC';
import NextPreviousButtons from '../../NextPreviousButtons';

interface Props {
	questions: any;
	questionnaire: any;
	onQuestionnaireBlur: (value?: {}) => void;
	onQuestionnaireChange: (value?: {}) => void;
	nextStep: (e: any) => void;
	prevStep: (e: any) => void;
	gender?: string;
}
const ReproductiveQuestion: React.StatelessComponent<Props> = props => {
	const { gender, questionnaire, onQuestionnaireBlur, onQuestionnaireChange } = props;
	const isNextDisabled = function () {
		if (!props.questionnaire[questionName].isValid ||
			(props.questionnaire[questionName].abnormalMammogram &&
				props.questionnaire[questionName].abnormalMammogramRepeat == null) ||
			(props.questionnaire[questionName].breastImagingTestOrPAPTest &&
				props.questionnaire[questionName].breastImagingTestOrPAPTestRepeat == null) ||
			(props.questionnaire[questionName].abnormalPSATest &&
				props.questionnaire[questionName].abnormalPSATestRepeat == null)) {
			return true;
		}

		return false;
	};
	return (
		<div className="form-group mb-0">
			<Label>{props.questions[questionName]}</Label>
			<div className="section-base section-bordered mt-1 form-group">
				<CheckboxGroup
					title="Reproductive system disorders, including:"
					className="mb-2"
					checkOptions={[
						{
							name: 'abnormalMammogram',
							label: 'Abnormal mammogram or breast imaging',
							checked: questionnaire[questionName].abnormalMammogram,
							onBlur: onQuestionnaireBlur,
							onChange: onQuestionnaireChange,
							conditionalChildren: (
								<FormCheckConditional isOpen={props.questionnaire[questionName].abnormalMammogram}>
									<ToggleSwitch
										labelText={props.questions.abnormalMammogramRepeat}
										className="mb-2 toggle-yes-no"
										name="abnormalMammogramRepeat"
										onChildren="Yes"
										offChildren="No"
										onBlur={onQuestionnaireBlur}
										onChange={onQuestionnaireChange}
										checked={props.questionnaire[questionName].abnormalMammogramRepeat}
									/>
								</FormCheckConditional>
							)
						},
						gender === 'female' ?
							{
								name: 'breastImagingTestOrPAPTest',
								label: 'Abnormal PAP test',
								checked: questionnaire[questionName].breastImagingTestOrPAPTest,
								onBlur: onQuestionnaireBlur,
								onChange: onQuestionnaireChange,
								conditionalChildren: (
									<FormCheckConditional isOpen={props.questionnaire[questionName].breastImagingTestOrPAPTest}>
										<ToggleSwitch
											labelText={props.questions.breastImagingTestOrPAPTestRepeat}
											className="mb-2 toggle-yes-no"
											name="breastImagingTestOrPAPTestRepeat"
											onChildren="Yes"
											offChildren="No"
											onBlur={onQuestionnaireBlur}
											onChange={onQuestionnaireChange}
											checked={props.questionnaire[questionName].breastImagingTestOrPAPTestRepeat}
										/>
									</FormCheckConditional>
								)
							} :
							{
								name: 'abnormalPSATest',
								label: 'Abnormal prostate (PSA) test',
								checked: questionnaire[questionName].abnormalPSATest,
								onBlur: onQuestionnaireBlur,
								onChange: onQuestionnaireChange,
								conditionalChildren: (
									<FormCheckConditional isOpen={props.questionnaire[questionName].abnormalPSATest}>
										<ToggleSwitch
											labelText={props.questions.abnormalPSATestRepeat}
											className="mb-2 toggle-yes-no"
											name="abnormalPSATestRepeat"
											onChildren="Yes"
											offChildren="No"
											onBlur={onQuestionnaireBlur}
											onChange={onQuestionnaireChange}
											checked={props.questionnaire[questionName].abnormalPSATestRepeat}
										/>
									</FormCheckConditional>
								)
							},
						{
							name: 'abnormalBiopsy',
							label: 'Abnormal biopsy',
							checked: questionnaire[questionName].abnormalBiopsy,
							onBlur: onQuestionnaireBlur,
							onChange: onQuestionnaireChange
						},
						{
							name: 'reproductiveDisorderOther',
							label: 'Other',
							checked: questionnaire[questionName].reproductiveDisorderOther,
							onBlur: onQuestionnaireBlur,
							onChange: onQuestionnaireChange,
							conditionalChildren: (
								<FormCheckConditional isOpen={questionnaire[questionName].reproductiveDisorderOther}>
									<TextInput
										labelText="Please specify:"
										name="reproductiveDisorderOtherDetails"
										onBlur={onQuestionnaireBlur}
										onChange={onQuestionnaireChange}
										value={questionnaire[questionName].reproductiveDisorderOtherDetails}
										className="mb-2"
									/>
								</FormCheckConditional>
							)
						},
						{
							name: 'reproductiveNone',
							label: 'None of the above apply to me',
							checked: questionnaire[questionName].reproductiveNone,
							onBlur: onQuestionnaireBlur,
							onChange: onQuestionnaireChange,
							className: 'border-top pt-2'
						},
					]}
				/>
			</div>
			<NextPreviousButtons nextStep={props.nextStep} prevStep={props.prevStep} isNextDisabled={isNextDisabled} />
		</div>
	);
};

const questionName = 'reproductive';
const hocConfig = {
	questionName: questionName,
	otherName: 'reproductiveDisorderOther',
	otherDetailsName: 'reproductiveDisorderOtherDetails'
};
export default handleNoneOptionAndValidationHOC(ReproductiveQuestion, hocConfig);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/medicalQuestions/medicalQuestion2/ReproductiveQuestion.tsx